<template>
    <v-select
        :items="languages"
        v-model="currentLanguageCode"
        item-value="code"
        item-text="name"
        @change="setLanguage"
        :solo="!showLabel"
        :flat="!showLabel"
        :dense="!showLabel"
        :label="showLabel ? $translate(label) : null"
        :hide-details="!showLabel"
        :style="style"
        background-color="transparent"
    >
        <template v-slot:selection="{ item }">
            <div class="selected-language">
                <img :src="item.flag.src" :alt="item.flag.alt" class="flag-icon"> <template v-if="!compact">{{ item.name }}</template>
            </div>
        </template>
        <template v-slot:item="{ item }">
            <img :src="item.flag.src" :alt="item.flag.alt" class="flag-icon"> {{ item.name }}
        </template>
    </v-select>
</template>

<script>
export default {
    name: 'zoezi-language-menu',

    zoezi: {
        title: 'Language selector',
        icon: 'mdi-flag'
    },

    props: {
        showLabel: {
            title: 'Show label',
            type: Boolean,
            default: false
        },
        label: {
            title: 'Label',
            type: String,
            default: 'Language'
        },
        compact: {
            title: 'Compact style',
            type: Boolean,
            default: false
        }
    },

    data: () => ({
        languages: [],
        currentLanguageCode: null
    }),

    computed: {
        style() {
            if (this.compact) {
                return {
                    'max-width': '70px'
                }
            }

            return null;
        }
    },

    watch: {
        '$store.state.language': {
            immediate: true,
            handler(lang) {
                this.currentLanguageCode = lang;
            }
        }
    },

    methods: {
        setLanguage(lang) {
            this.$store.dispatch('setLanguage', {language: lang, changeOnServer: true});
            this.currentLanguageCode = lang;
        }
    },
    mounted() {
        this.$api.get('/api/translation/language/get/all').then(languages => {
            this.languages = languages.map(language => ({
                name: language.name,
                code: language.code,
                flag: {
                    src: `/assets/img/flags/${language.code}.png`,
                    alt: language.name,
                }
            })).sort((a, b) => a.name.localeCompare(b.name));
        })
    }
}
</script>

<style scoped>
.flag-icon {
    width: 24px;
    height: 16px;
    margin-right: 8px;
}

.select-language {
    display: flex;
    align-items: center;
}
</style>
